<template>
  <div>
    <elearning-course
      v-for="(course, index) in courses"
      :key="course.id"
      v-model="courses[index]"
      :model-value="course"
      :index="course.id"
      :certificates="certificates"
    />
  </div>
</template>

<script>
import axios from 'axios';

import { lookup } from '../lookup/lookup';
import ElearningCourse from './elearningCourse.vue';

export default {
  components: { ElearningCourse },
  props: ['modelValue'],
  data() {
    return {
      courses: [],
      certificates: [],
    };
  },

  async mounted() {
    const response = await axios.get('/api/elearning/courses');
    const certificates = await lookup.computed.certificates();

    this.courses = response.data;
  },

  methods: {

  },
};
</script>
